import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import {
	DropdownMenu,
	DropdownMenuItem
} from "src/common/components/DropdownMenu";
import { messages } from "src/views/user-list/messages";

export const UserState: React.FunctionComponent<{
	id: string;
	inactive: boolean;
	activateUser(id: string): unknown;
	deactivateUser(id: string): unknown;
}> = ({ id, inactive, activateUser, deactivateUser }) => {
	const { formatMessage } = useIntl();
	return (
		<DropdownMenu
			label={
				inactive
					? formatMessage(messages.inactive)
					: formatMessage(messages.active)
			}
		>
			<DropdownMenuItem
				onClick={() => {
					if (inactive) {
						activateUser(id);
					}
				}}
			>
				<FormattedMessage {...messages.active} />
			</DropdownMenuItem>
			<DropdownMenuItem
				onClick={() => {
					if (!inactive) {
						deactivateUser(id);
					}
				}}
			>
				<FormattedMessage {...messages.inactive} />
			</DropdownMenuItem>
		</DropdownMenu>
	);
};
